import './components/_globals';
import './data/submit-button';
import Vue from 'vue';
import './plugins/axios';
import CoffeeGenerator from './CoffeeGenerator.vue';
import store from './store';
import { i18n } from './i18n';

const flattenObject = (ob: any) => {
  let toReturn: any = {};
  for (let i in ob) {
    if (!Object.prototype.hasOwnProperty.call(ob, i)) continue;
    if (typeof ob[i] == 'object') {
      let flatObject = flattenObject(ob[i]);
      for (let x in flatObject) {
        if (!Object.prototype.hasOwnProperty.call(flatObject, x)) continue;
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else toReturn[i] = ob[i];
  }
  return toReturn;
};

const stepsContentFlat = flattenObject((store as any).state.steps.stepsContent);
const stepsContentFlatKeys = Object.keys(stepsContentFlat);
for (let key in stepsContentFlatKeys) {
  if (stepsContentFlatKeys[key].includes('.image')) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = stepsContentFlat[stepsContentFlatKeys[key]];
    document.querySelector('head')?.appendChild(link);
  }
}

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  render: (h) => h(CoffeeGenerator),
}).$mount('#coffeeGenerator');
